export default __webpack_public_path__ + "static/media/checkmarkHC.1de26301.svg";